<app-back-header
  *ngIf="invoiceForm.get('is_draft')?.value == false"
  [headerText]="'Torna alle Fatture'"
  (backAction)="onCancel()"
  class="sticky-top">
</app-back-header>

<app-back-header
  *ngIf="invoiceForm.get('is_draft')?.value == true"
  [headerText]="'Torna alle bozze'"
  (backAction)="onCancelDraft()"
  class="sticky-top">
</app-back-header>

<!-- I blocchi entrano uno dopo l'altro dall'alto (.izy-enter + ritardo per
     posizione, come in dashboard): la pagina si compone invece di comparire
     tutta di scatto. -->
<div
  class="d-flex justify-content-between align-items-start mt-3 ms-1 mb-3 w-100 izy-enter"
  style="animation-delay: 0ms">
  <div>
    <h3 class="m-0">Dettaglio {{ displayDocumentType }}</h3>

    <p
      *ngIf="invoiceForm.get('is_draft')?.value == false"
      class="m-0 text-muted">
      I campi inseriti non sono modificabili.
    </p>
    <p
      *ngIf="invoiceForm.get('is_draft')?.value == true"
      class="m-0 text-muted">
      Clicca su "Modifica" per apportare cambiamenti alla bozza.
    </p>

    <p class="m-0 mt-1 small text-muted" *ngIf="invoiceForm.get('healthcare_invoice')?.value === true">Questa {{ displayDocumentType }} riguarda una prestazione sanitaria.</p>
    <p class="m-0 mt-1 small text-muted" *ngIf="invoiceForm.get('paper_invoice')?.value === true">Questa {{ displayDocumentType }} è solo cartacea.</p>
  </div>
</div>

<div
  *ngIf="invoiceForm.get('is_draft')?.value == false"
  class="d-flex align-items-center flex-wrap gap-2 ms-1 mb-3 izy-enter"
  style="animation-delay: 60ms">
  <!-- paid status badge -->
  <mat-chip
    class="status-chip"
    [ngClass]="invoiceForm.get('is_paid')?.value ? 'chip-paid' : 'chip-unpaid'"
    matTooltip="Indica se la fattura è stata incassata."
    [matTooltipShowDelay]="showDelay.value"
    [matTooltipHideDelay]="hideDelay.value"
    selected
  >
    <mat-icon matChipAvatar>{{
      invoiceForm.get("is_paid")?.value ? "check_circle" : "cancel"
    }}</mat-icon>
    {{ invoiceForm.get("is_paid")?.value ? "INCASSATA" : "NON INCASSATA" }}
  </mat-chip>

  <!-- invoice send status badge -->
  <mat-chip
    class="status-chip"
    [color]="getStatusColor(invoiceForm.get('status')?.value)"
    [ngClass]="{'chip-scartata': invoiceForm.get('status')?.value === 'SCARTATA', 'chip-accepted': invoiceForm.get('status')?.value === 'INVIATA' || invoiceForm.get('status')?.value === 'ACCETTATA', 'chip-trasmessa': invoiceForm.get('status')?.value === 'TRASMESSA'}"
    (click)="handleInfoClick($event)"
    matTooltip="Informazioni aggiuntive sullo stato di invio."
    [matTooltipShowDelay]="showDelay.value"
    [matTooltipHideDelay]="hideDelay.value"
    selected
  >
    {{ invoiceForm.get("status")?.value }}
  </mat-chip>
  <button
    mat-icon-button
    class="me-0 izy-info-btn"
    (click)="handleInfoClick($event)"
    matTooltip="Informazioni aggiuntive sullo stato di invio."
    [matTooltipShowDelay]="showDelay.value"
    [matTooltipHideDelay]="hideDelay.value"
    >
    <mat-icon>
      info
    </mat-icon>
  </button>
</div>

<p
  *ngIf="
    invoiceForm.get('is_draft')?.value == false &&
    invoiceForm.get('is_paid')?.value &&
    currentInvoice?.marked_paid_at
  "
  class="small text-muted mb-3"
>
  Segnata incassata il
  {{ currentInvoice?.marked_paid_at | date: "dd/MM/yyyy, HH:mm" }}
</p>

<div
  *ngIf="invoiceForm.get('is_draft')?.value == true"
  class="d-flex align-items-center flex-wrap gap-2 ms-1 mb-3 izy-enter"
  style="animation-delay: 60ms">
  <!-- draft badge -->
  <mat-chip class="status-chip chip-bozza" selected>
    <mat-icon matChipAvatar>edit_document</mat-icon>
    Bozza
  </mat-chip>
</div>


<div class="col-md-12 d-flex flex-column mb-3 izy-enter" style="animation-delay: 120ms">
  <mat-expansion-panel
    class="h-100 mt-md-0 mt-3 custom-card izy-sharp-bl"
    #panelclient>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Cliente
        </mat-panel-title>
        <mat-panel-description>
          {{ company_name ?company_name : 'Nessuno' }}
          <span class="panel-state">{{ panelclient.expanded ? 'Chiudi' : 'Apri' }}</span>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="d-flex flex-column h-100 justify-content-center">

        <!-- Show when no company is selected -->
        <div *ngIf="!company_id" class="izy-empty-box text-center py-4">
          <mat-icon class="mb-2">face</mat-icon>
          <p class="mb-0">Nessun cliente selezionato</p>
        </div>

        <div class="row">
          <!-- Show when company is selected -->
          <div *ngIf="company_name" class="company-details w-sm-50">
            <div class="mb-3">
              <label class="form-label fw-bold text-secondary">Nome</label>
              <div class="p-2 bg-light rounded border">
                {{ company_name }}
              </div>
            </div>
          </div>

          <div *ngIf="company_iva_number" class="company-details w-sm-50">
            <div class="mb-3">
              <label class="form-label fw-bold text-secondary">Partita IVA</label>
              <div class="p-2 bg-light rounded border">
                {{ company_iva_number }}
              </div>
            </div>
          </div>

          <div *ngIf="company_address" class="company-details w-sm-50">
            <div class="mb-3">
              <label class="form-label fw-bold text-secondary">Indirizzo</label>
              <div class="p-2 bg-light rounded border">
                {{ company_address }}
              </div>
            </div>
          </div>

          <div *ngIf="company_addressee_code" class="company-details w-sm-50">
            <div class="mb-3">
              <label class="form-label fw-bold text-secondary">Codice SDI</label>
              <div class="p-2 bg-light rounded border">
                {{ company_addressee_code }}
              </div>
            </div>
          </div>
        </div>

      </div>

  </mat-expansion-panel>
</div>

<form [formGroup]="invoiceForm">
  <mat-expansion-panel
    class="mb-3 col-md-12 d-flex flex-column custom-card izy-sharp-bl izy-enter"
    style="animation-delay: 180ms"
    #panel
    >
      <mat-expansion-panel-header>
      <mat-panel-title>
        Documento
      </mat-panel-title>
      <mat-panel-description>
        Num. {{ invoiceForm.get('progressive_number')?.value ? invoiceForm.get('progressive_number')?.value : 'n' }}/{{ invoiceForm.get('enumeration')?.value ? invoiceForm.get('enumeration')?.value : 'Anno' }}
        <span class="panel-state">{{ panel.expanded ? 'Chiudi' : 'Apri' }}</span>
      </mat-panel-description>
    </mat-expansion-panel-header>

      <div class="row">

        <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Numero progressivo</mat-label>
          <input
            matInput
            formControlName="progressive_number"
            [readonly]="shouldBeReadonly"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Numerazione</mat-label>
          <input matInput formControlName="enumeration"  [readonly]="shouldBeReadonly" />
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="w-sm-25-mobile-25"
          *ngIf="!isEditMode"
          >
          <mat-label>Valuta</mat-label>
          <input matInput formControlName="currency"  readonly />
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="w-sm-25"
          *ngIf="isEditMode"
          >
            <mat-label>Valuta</mat-label>
            <mat-select
              formControlName="currency"
              name="currency"
              class="izy-select-trigger"
              panelClass="izy-select-panel izy-select-panel--form"
              required
            >
              <mat-option
                *ngFor="let currency of currencyOptions"
                [value]="currency.code"
              >
                {{ currency.code }} - {{ currency.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="w-sm-25-mobile-25"
          *ngIf="!isEditMode"
          >
          <mat-label>Lingua</mat-label>
          <input
            matInput
            [value]="getLanguageDisplayName()"
            readonly
          />
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="w-sm-25"
          *ngIf="isEditMode"
          >
            <mat-label>Lingua</mat-label>
            <mat-select
              formControlName="language"
              name="language"
              class="izy-select-trigger"
              panelClass="izy-select-panel izy-select-panel--form"
              required
            >
              <mat-option
                *ngFor="let language of languageOptions"
                [value]="language.code"
              >
                {{ language.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

      </div>

      <div class="row">

        <mat-form-field appearance="outline" class="w-sm-50">
          <mat-label>Descrizione/Oggetto</mat-label>
          <textarea
            matInput
            formControlName="description"
            [readonly]="shouldBeReadonly"
          ></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-50">
          <mat-label>Note (opzionali)</mat-label>
          <textarea
            matInput
            formControlName="notes"
            [readonly]="shouldBeReadonly"
          ></textarea>
        </mat-form-field>

        <div class="ateco-code-section">
          <p class="mt-1 ms-1 small text-muted">Codice ATECO di riferimento della fattura:</p>

          <div class="ateco-readonly d-flex align-items-center justify-content-between gap-2">
            <div class="ateco-info">
              <p class="mb-0 small text-muted">{{ ateco_code_data?.name || 'Non disponibile' }}</p>
              <p class="mb-0">
                <strong *ngIf="ateco_code_data">
                  {{ ateco_code_data?.ateco_division || '' }}.{{ ateco_code_data?.ateco_class || '' }}.{{ ateco_code_data?.ateco_subcategory || '' }}
                </strong>
                <span *ngIf="!ateco_code_data" class="text-muted fst-italic">Nessun codice ATECO selezionato</span>
              </p>
            </div>

            <button
              mat-stroked-button
              class="flex-shrink-0 izy-button-ghost custom-button-border"
              (click)="changeInvoiceAtecoCode()"
              [disabled]="isLoading"
            >
              <mat-icon>edit</mat-icon>
              {{ ateco_code_data ? 'Modifica' : 'Seleziona' }}
            </button>
          </div>
        </div>

      </div>

  </mat-expansion-panel>

  <mat-expansion-panel
    class="mb-3 col-md-12 d-flex flex-column custom-card izy-sharp-bl izy-enter"
    style="animation-delay: 240ms"
    #panel2
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          Fatturazione
        </mat-panel-title>
        <mat-panel-description>
          {{ invoiceForm.get('document_type')?.value ? displayDocumentType : 'Fattura' }} - {{ formatFormDate('emission_date') }}
          <span class="panel-state">{{ panel2.expanded ? 'Chiudi' : 'Apri' }}</span>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="row">

        <mat-form-field *ngIf="!isEditMode" appearance="outline" class="w-sm-25">
          <mat-label>Data di emissione</mat-label>
          <input
            matInput
            formControlName="emission_date"
            readonly
            [value]="formatFormDate('emission_date')"
          />
        </mat-form-field>

        <mat-form-field *ngIf="isEditMode" appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Data di emissione</mat-label>
          <input
            matInput
            [matDatepicker]="emissionDatePicker"
            formControlName="emission_date"
            name="emission_date"
            required
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="emissionDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #emissionDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field *ngIf="!isEditMode" appearance="outline" class="w-sm-25">
          <mat-label>Data di pagamento</mat-label>
          <input
            matInput
            formControlName="payment_date"
            readonly
            [value]="formatFormDate('payment_date')"
          />
        </mat-form-field>

        <mat-form-field *ngIf="isEditMode" appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Data di pagamento</mat-label>
          <input
            matInput
            [matDatepicker]="paymentDatePicker"
            formControlName="payment_date"
            name="payment_date"
            required
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="paymentDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #paymentDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field *ngIf="!isEditMode" appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Esigibilità IVA</mat-label>
          <input matInput [value]="invoiceForm.get('iva_collectability')?.value" disabled readonly />
        </mat-form-field>

        <mat-form-field *ngIf="isEditMode" appearance="outline" class="w-sm-25-mobile-25" disabled>
            <mat-label>Esigibilità IVA</mat-label>
            <mat-select
              formControlName="iva_collectability"
              name="iva_collectability"
              class="izy-select-trigger"
              panelClass="izy-select-panel izy-select-panel--form"
              [disabled]="true"
            >
            </mat-select>
          </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Codice destinatario</mat-label>
          <input
            matInput
            formControlName="addressee_code"
            [readonly]="shouldBeReadonly"
           />
        </mat-form-field>

      </div>

      <div class="row">

        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Tipo documento</mat-label>
          <input
            matInput
            [value]="displayDocumentType + (invoiceForm.get('p_a')?.value ? ' PA' : '')"
            readonly
            disabled
            placeholder="Seleziona tipo documento" />
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="w-sm-25"
          *ngIf="!isEditMode"
          >
          <mat-label>Metodo di pagamento</mat-label>
          <input
            matInput
            [value]="displayPaymentMethodType"
            readonly
            placeholder="Seleziona tipo documento" />
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="w-sm-25"
          *ngIf="isEditMode"
          >
            <mat-label>Metodo di pagamento</mat-label>
            <mat-select
              formControlName="payment_method"
              name="payment_method"
              class="izy-select-trigger"
              panelClass="izy-select-panel izy-select-panel--form"
              required
            >
              <mat-option
                *ngFor="let method of paymentMethodOptions"
                [value]="method.code"
              >
                {{ method.code }} - {{ method.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-50">
          <mat-label>IBAN</mat-label>
          <input
            matInput formControlName="iban"
            [readonly]="shouldBeReadonly"
            />
        </mat-form-field>

      </div>

      <div class="row">

        <mat-form-field
          appearance="outline"
          class="w-sm-25"
          >
          <mat-label>Marca da bollo a carico del cliente</mat-label>
          <input
            matInput
            [value]="getBooleanDisplay(invoiceForm.get('revenue_stamp_for_company')?.value)"
            readonly
            disabled
          />
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="w-sm-25"
          *ngIf="!isEditMode"
          >
          <mat-label>Pubblica Amministrazione</mat-label>
          <input
            matInput
            [value]="getBooleanDisplay(invoiceForm.get('p_a')?.value)"
            readonly
          />
        </mat-form-field>

        <div class="w-sm-25" *ngIf="isEditMode">
          <mat-slide-toggle
            name="revenueStampCustomer"
            formControlName="p_a"
            color="primary"
            class="mt-2 toggle-spacing"
            matTooltip="Fattura per Pubblica Amministrazione."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
          >
            Pubblica Amministrazione
          </mat-slide-toggle>
        </div>

        <!-- For healthcare_invoice -->
        <mat-form-field
          appearance="outline"
          class="w-sm-25"
          *ngIf="!isEditMode"
          >
          <mat-label>Fattura sanitaria</mat-label>
          <input
            matInput
            [value]="getBooleanDisplay(invoiceForm.get('healthcare_invoice')?.value)"
            readonly
          />
        </mat-form-field>

        <div class="w-sm-25" *ngIf="isEditMode">
          <mat-slide-toggle
            name="healthcare_invoice"
            formControlName="healthcare_invoice"
            color="primary"
            class="mt-2 toggle-spacing"
            matTooltip="Fattura prestazione sanitaria. Queste fatture non vengono inoltrate allo SDI."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
          >
            Fattura prestazione sanitaria
          </mat-slide-toggle>
        </div>

        <!-- For paper_invoice -->
        <mat-form-field
          appearance="outline"
          class="w-sm-25"
          *ngIf="!isEditMode"
          >
          <mat-label>Fattura cartacea</mat-label>
          <input
            matInput
            [value]="getBooleanDisplay(invoiceForm.get('paper_invoice')?.value)"
            readonly
          />
        </mat-form-field>

        <div class="w-sm-25" *ngIf="isEditMode">
          <mat-slide-toggle
            name="paper_invoice"
            formControlName="paper_invoice"
            color="primary"
            class="mt-2 toggle-spacing"
            matTooltip="Fattura cartacea. Queste fatture non vengono inoltrate allo SDI."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
          >
            Fattura cartacea
          </mat-slide-toggle>
        </div>

      </div>

      <!-- Stesso pannello "Dati aggiuntivi fattura" di new-invoice: superficie
           bianca bordata nera 2px, angolo basso-sinistro vivo e velo giallo
           (accent-2) in hover sull'header. -->
      <mat-expansion-panel class="mt-2 mb-2 izy-extra-data-panel izy-sharp-bl">

        <mat-expansion-panel-header>
          <mat-panel-title
            matTooltip="Clicca su questo pannello per espandere la scheda dei campi avanzati della fattura (come CIG, CUP ecc...)."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
          >
            <h6>Dati aggiuntivi fattura:</h6>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="row">
          <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>ID documento</mat-label>
            <input matInput formControlName="document_id" [readonly]="shouldBeReadonly" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>Data documento</mat-label>
            <input matInput formControlName="id_document_date" [readonly]="shouldBeReadonly" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>Voce documento</mat-label>
            <input matInput formControlName="id_document_voice" [readonly]="shouldBeReadonly" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>Codice Comm. Conv.</mat-label>
            <input matInput formControlName="cod_comm_conv" [readonly]="shouldBeReadonly" />
          </mat-form-field>
        </div>

        <div class="row">
          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Codice CIG</mat-label>
            <input matInput formControlName="cig" [readonly]="shouldBeReadonly" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Codice CUP</mat-label>
            <input matInput formControlName="cup" [readonly]="shouldBeReadonly" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>Riferimento num. linea</mat-label>
            <input matInput formControlName="rif_righe_fatt" [readonly]="shouldBeReadonly" />
          </mat-form-field>
        </div>

      </mat-expansion-panel>
  </mat-expansion-panel>

  <mat-expansion-panel
    class="mb-3 col-md-12 d-flex flex-column custom-card izy-sharp-bl izy-enter"
    style="animation-delay: 300ms"
    #panel3
    >
      <mat-expansion-panel-header>
          <mat-panel-title>
            Prestazioni
          </mat-panel-title>
          <mat-panel-description>
            Aggiunte: <span class="article-badge">{{ productServices.length }}</span>
            <span class="panel-state">{{ panel3.expanded ? 'Chiudi' : 'Apri' }}</span>
          </mat-panel-description>
        </mat-expansion-panel-header>

      <div class="hidden-mobile">

       <!-- Products and services table -->
      <div *ngIf="isLoadingProducts" class="loading-container">
        <p>Caricamento prodotti/servizi...</p>
      </div>

      <div *ngIf="!isLoadingProducts && productServices.length === 0" class="no-data-container">
        <mat-icon>sentiment_neutral</mat-icon>
        <p>Nessun prodotto o servizio associato a questa fattura.</p>
      </div>

      <div *ngIf="!isLoadingProducts && productServices.length > 0" class="table-container">
        <table mat-table [dataSource]="productServices" multiTemplateDataRows>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Nome </th>
            <td mat-cell *matCellDef="let product"> {{product.name}} </td>
          </ng-container>

          <!-- Quantity Column -->
          <ng-container matColumnDef="quantity">
            <th mat-header-cell *matHeaderCellDef> Quantità </th>
            <td mat-cell *matCellDef="let product"> {{product.quantity}} </td>
          </ng-container>

          <!-- Units Column -->
          <ng-container matColumnDef="units">
            <th mat-header-cell *matHeaderCellDef> Unità </th>
            <td mat-cell *matCellDef="let product"> {{product.units}} </td>
          </ng-container>

          <!-- Gross Amount Column -->
          <ng-container matColumnDef="gross_amount">
            <th mat-header-cell *matHeaderCellDef> Importo Lordo </th>
            <td mat-cell *matCellDef="let product"> {{ formatCardAmount(product.gross_amount) }} </td>
          </ng-container>

          <!-- Discount Column -->
          <ng-container matColumnDef="discount">
            <th mat-header-cell *matHeaderCellDef> Sconto (%) </th>
            <td mat-cell *matCellDef="let product"> {{product.discount}}% </td>
          </ng-container>

          <!-- IVA Percentage Column -->
          <ng-container matColumnDef="iva_percentage">
            <th mat-header-cell *matHeaderCellDef> IVA (%) </th>
            <td mat-cell *matCellDef="let product"> {{ product.iva_percentage}}% </td>
          </ng-container>

          <!-- IVA Amount Column -->
          <ng-container matColumnDef="iva_amount">
            <th mat-header-cell *matHeaderCellDef> Importo IVA </th>
            <td mat-cell *matCellDef="let product"> {{ formatCardAmount(product.iva_amount) }} </td>
          </ng-container>

          <!-- Final Amount Column -->
          <ng-container matColumnDef="final_amount">
            <th mat-header-cell *matHeaderCellDef> Totale </th>
            <td mat-cell *matCellDef="let product"> {{ formatCardAmount(product.final_amount) }} </td>
          </ng-container>

          <ng-container matColumnDef="descriptionDetail">
            <td mat-cell *matCellDef="let product" [attr.colspan]="displayedColumns.length" class="description-cell">
              <div class="description-content" *ngIf="product.description">
                <strong>Descrizione:</strong> {{ product.description }}
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          <tr mat-row
      *matRowDef="let row; columns: ['descriptionDetail']"
      class="description-row"
      [class.hidden-row]="!row.description">
  </tr>

        </table>
      </div>

      <!-- Summary of product services -->
      <div *ngIf="!isLoadingProducts && productServices.length > 0" class="product-summary mt-2 mb-1">
        <div class="summary-item">
          <span class="label">Totale prodotti/servizi:</span>
          <span class="value">{{ formatCardAmount(getTotalProductServices()) }}</span>
        </div>
        <div class="izy-divider-h"></div>
        <div class="summary-item">
          <span class="label">Numero voci:</span>
          <span class="value">{{ productServices.length }}</span>
        </div>
      </div>

    </div>

    <!-- mobile cards -->
    <div class="visible-mobile">
       <h6 class="mt-2">Prodotti e servizi:</h6>

      <!-- Mobile loading state -->
      <div *ngIf="isLoadingProducts" class="loading-container">
        <p>Caricamento prodotti/servizi...</p>
      </div>

      <!-- Mobile empty state -->
      <div *ngIf="!isLoadingProducts && productServices.length === 0" class="no-data-container">
        <mat-icon>sentiment_neutral</mat-icon>
        <p>Nessun prodotto o servizio associato a questa fattura.</p>
      </div>

      <!-- Mobile product cards -->
      <div *ngIf="!isLoadingProducts && productServices.length > 0" class="mobile-products-container">
        <mat-card *ngFor="let product of productServices" class="product-card izy-sharp-bl mb-2">
          <mat-card-header class="pb-2">
            <mat-card-title class="product-name">{{ product.name }}</mat-card-title>
          </mat-card-header>

          <mat-card-content class="product-details">
            <div class="detail-row">
              <span class="label">Quantità:</span>
              <span class="value">{{ product.quantity }} {{ product.units }}</span>
            </div>

            <div class="detail-row">
              <span class="label">Importo lordo:</span>
              <span class="value">{{ formatCardAmount(product.gross_amount) }}</span>
            </div>

            <div class="detail-row" *ngIf="product.discount">
              <span class="label">Sconto:</span>
              <span class="value">{{ product.discount }}%</span>
            </div>

            <div class="detail-row">
              <span class="label">IVA:</span>
              <span class="value">{{ product.iva_percentage }}% ({{ formatCardAmount(product.iva_amount) }})</span>
            </div>

            <div class="izy-divider-h my-2"></div>

            <div class="detail-row total">
              <span class="label">Totale:</span>
              <span class="value">{{ formatCardAmount(product.final_amount) }}</span>
            </div>
          </mat-card-content>
        </mat-card>

        <!-- Mobile summary -->
        <div class="product-summary mt-3">
          <div class="izy-divider-h"></div>
          <div class="summary-item">
            <span class="label">Totale prodotti/servizi:</span>
            <span class="value">{{ formatCardAmount(getTotalProductServices()) }}</span>
          </div>
          <div class="izy-divider-h"></div>
          <div class="summary-item">
            <span class="label">Numero voci:</span>
            <span class="value">{{ productServices.length }}</span>
          </div>
        </div>
      </div>
    </div>

  </mat-expansion-panel>

  <mat-card
    class="mb-3 col-md-12 d-flex flex-column custom-card izy-sharp-bl izy-enter"
    style="animation-delay: 360ms">
    <mat-card-content>
      <h4 class="m-2">Riepilogo:</h4>

      <p
        class="ms-2 colored-primary-text"
        *ngIf="invoiceForm.get('healthcare_invoice')?.value === true || invoiceForm.get('paper_invoice')?.value === true"
      >
      Questa {{ displayDocumentType }} è solo cartacea. Non verrà emessa come {{ displayDocumentType }} Elettronica.</p>

      <mat-divider></mat-divider>
      <div class="summary-item">
        <span class="fw-medium">Competenze:</span>
        <span class="fw-medium">{{ formatCardAmount(invoiceForm.get('gross_amount')?.value) }}</span>
      </div>

      <div class="summary-item">
        <span class="label">Marca da bollo:</span>
        <span class="value"> {{ formatCardAmount(invoiceForm.get('revenue_stamp')?.value) }}</span>
      </div>

      <div class="summary-item" *ngIf="invoiceForm.get('discount_amount')?.value > 0">
        <span class="label" *ngIf="invoiceForm.get('discount_amount')?.value > 0">
          Sconto:
        </span>
        <span class="value" *ngIf="invoiceForm.get('discount_amount')?.value > 0">
          - {{ formatCardAmount(invoiceForm.get('discount_amount')?.value) }}
        </span>
      </div>

      <mat-divider *ngIf="invoiceForm.get('revenge')?.value > 0"></mat-divider>
      <div class="summary-item" *ngIf="invoiceForm.get('revenge')?.value > 0">
        <span class="label" *ngIf="invoiceForm.get('revenge')?.value > 0">
          Rivalsa ({{invoiceForm.get('revenge_rate')?.value}}%):
        </span>
        <span class="value" *ngIf="invoiceForm.get('revenge')?.value > 0">
          + {{ formatCardAmount(invoiceForm.get('revenge')?.value) }}
        </span>
      </div>

      <mat-divider class="summary-item" *ngIf="invoiceForm.get('pension_fund')?.value > 0"></mat-divider>
      <div class="summary-item" *ngIf="invoiceForm.get('pension_fund')?.value > 0">
        <span class="label" *ngIf="invoiceForm.get('pension_fund')?.value > 0">
          Cassa previdenziale ({{invoiceForm.get('pension_fund_rate')?.value}}%):
        </span>
        <span class="value" *ngIf="invoiceForm.get('pension_fund')?.value > 0">
          + {{ formatCardAmount(invoiceForm.get('pension_fund')?.value) }}
        </span>
      </div>
      <span class="ms-2 small text-muted" *ngIf="invoiceForm.get('pension_fund')?.value > 0">
         {{ getPensionFundDisplayName() }}
      </span>

      <mat-divider></mat-divider>
      <div class="summary-item">
        <span class="fw-medium">Imponibile:</span>
        <span class="fw-medium">{{ formatCardAmount(invoiceForm.get('taxable_amount')?.value) }}</span>
      </div>

      <mat-divider></mat-divider>
      <div class="summary-item">
        <span class="label">Iva ({{invoiceForm.get('iva_percentage')?.value}}%):</span>
        <span class="value">+ {{ formatCardAmount(invoiceForm.get('iva_amount')?.value) }}</span>
      </div>

      <mat-divider *ngIf="invoiceForm.get('withholding_advance_tax')?.value > 0"></mat-divider>
      <div class="summary-item" *ngIf="invoiceForm.get('withholding_advance_tax')?.value > 0">
        <span class="label" *ngIf="invoiceForm.get('withholding_advance_tax')?.value > 0"
          >Ritenuta d'acconto ({{invoiceForm.get('withholding_advance_tax_rate')?.value}}%):
        </span>
        <span class="value" *ngIf="invoiceForm.get('withholding_advance_tax')?.value > 0">
          - {{ formatCardAmount(invoiceForm.get('withholding_advance_tax')?.value) }}
        </span>
      </div>

      <mat-divider *ngIf="invoiceForm.get('withholding_tax')?.value > 0"></mat-divider>
      <div class="summary-item" *ngIf="invoiceForm.get('withholding_tax')?.value > 0">
        <span class="label" *ngIf="invoiceForm.get('withholding_tax')?.value > 0">
          Ritenuta ({{invoiceForm.get('withholding_tax_rate')?.value}}%):
        </span>
        <span class="value" *ngIf="invoiceForm.get('withholding_tax')?.value > 0">
          - {{ formatCardAmount(invoiceForm.get('withholding_tax')?.value) }}
        </span>
      </div>

      <div class="summary-item total">
        <span class="label">Totale da incassare:</span>
        <span class="value">{{ formatCardAmount(invoiceForm.get('amount')?.value) }}</span>
      </div>
    </mat-card-content>
  </mat-card>
</form>

  <!-- ---- Azioni ----
       Una sola azione primaria per schermata (petrol pieno): l'export del PDF
       su una fattura emessa, "Pubblica" su una bozza, "Salva modifiche" mentre
       la si modifica. Tutto il resto e' secondario: pillola bianca bordata
       nera (.izy-button-ghost + .custom-button-border). -->
  <div class="pb-3 izy-enter" style="animation-delay: 420ms">

    <!-- Versione Desktop -->
    <div class="hidden-mobile d-flex flex-wrap justify-content-end gap-2 mb-3">

      <!-- Bottoni sempre disponibili -->
      <button
        mat-stroked-button
        class="custom-button-border"
        [ngClass]="isExportPrimaryAction ? 'izy-button-primary' : 'izy-button-ghost'"
        (click)="downloadPdf()"
      >
        <mat-icon>print</mat-icon>
        Scarica PDF
      </button>
      <button
        mat-stroked-button
        class="izy-button-ghost custom-button-border"
        (click)="downloadXml()"
      >
        <mat-icon>download</mat-icon>
        Download XML
      </button>
      <button
        mat-stroked-button
        class="izy-button-ghost custom-button-border"
        (click)="sendInvoiceEmail()"
      >
        <mat-icon>outgoing_mail</mat-icon>
        Invia fattura per email
      </button>

      <!-- Modalità Visualizzazione -->
      <ng-container *ngIf="!isEditMode">
        <button
          *ngIf="invoiceForm.get('is_draft')?.value == true"
          mat-stroked-button
          class="izy-button-ghost custom-button-border"
          (click)="enableEditMode(); isEditMode = true"
        >
          <mat-icon>edit</mat-icon>
          Modifica bozza
        </button>
        <button
          *ngIf="invoiceForm.get('is_draft')?.value == false"
          mat-stroked-button
          class="izy-button-ghost custom-button-border"
          (click)="duplicateInvoice()"
          [disabled]="isLoading"
        >
          <mat-icon>copy_all</mat-icon>
          Duplica
        </button>

        <button
        *ngIf="invoiceForm.get('is_draft')?.value == true && !isEditMode"
        mat-stroked-button
        class="izy-button-primary custom-button-border"
        (click)="publishDraft()"
        [disabled]="isLoading"
        >
          <mat-icon>send</mat-icon>
          Pubblica
        </button>
      </ng-container>

      <!-- Modalità Modifica -->
      <ng-container *ngIf="isEditMode">
        <button
          mat-stroked-button
          class="izy-button-primary custom-button-border"
          (click)="saveDraft(); isEditMode = false"
          [disabled]="isLoading"
        >
          <mat-icon>save</mat-icon>
          Salva modifiche
        </button>
        <button
          mat-stroked-button
          class="izy-button-ghost custom-button-border"
          (click)="cancelEdit(); isEditMode = false"
          [disabled]="isLoading"
        >
          <mat-icon>cancel</mat-icon>
          Annulla
        </button>
      </ng-container>
    </div>

    <!-- Versione Mobile -->
    <div class="visible-mobile">
      <div class="row g-2 mb-2">
        <div class="col-6">
          <button
            mat-stroked-button
            class="w-100 custom-button-border"
            [ngClass]="isExportPrimaryAction ? 'izy-button-primary' : 'izy-button-ghost'"
            (click)="downloadPdf()"
          >
            <mat-icon>print</mat-icon>
            PDF
          </button>
        </div>
        <div class="col-6">
          <button
            mat-stroked-button
            class="w-100 izy-button-ghost custom-button-border"
            (click)="downloadXml()"
          >
            <mat-icon>download</mat-icon>
            XML
          </button>
        </div>
      </div>

      <!-- Mail send button for mobile -->
      <div
        *ngIf="invoiceForm.get('is_draft')?.value == false"
        class="row g-2 mb-2">
        <div class="col-12">
          <button
            mat-stroked-button
            class="w-100 izy-button-ghost custom-button-border"
            (click)="sendInvoiceEmail()"
          >
            <mat-icon>outgoing_mail</mat-icon>
            Invia fattura per email
          </button>
        </div>
      </div>

      <div class="row g-2 mb-3">

        <!-- Modalità Visualizzazione -->
        <ng-container *ngIf="!isEditMode">
          <div class="col-12" *ngIf="invoiceForm.get('is_draft')?.value == true">
            <button
              mat-stroked-button
              class="w-100 izy-button-ghost custom-button-border"
              (click)="enableEditMode(); isEditMode = true"
            >
              <mat-icon>edit</mat-icon>
              Modifica
            </button>
          </div>
          <div class="col-12" *ngIf="invoiceForm.get('is_draft')?.value == false">
            <button
              mat-stroked-button
              class="w-100 izy-button-ghost custom-button-border"
              (click)="duplicateInvoice()"
              [disabled]="isLoading"
            >
              <mat-icon>copy_all</mat-icon>
              Duplica
            </button>
          </div>
          <div class="col-12" *ngIf="invoiceForm.get('is_draft')?.value == true && !isEditMode">
            <button
              mat-stroked-button
              class="w-100 izy-button-primary custom-button-border"
              (click)="publishDraft()"
              [disabled]="isLoading"
            >
              <mat-icon>send</mat-icon>
              Pubblica
            </button>
          </div>
        </ng-container>

        <!-- Modalità Modifica -->
        <ng-container *ngIf="isEditMode">
          <div class="col-12">
            <button
              mat-stroked-button
              class="w-100 izy-button-primary custom-button-border"
              (click)="saveDraft(); isEditMode = false"
              [disabled]="isLoading"
            >
              <mat-icon>save</mat-icon>
              Salva
            </button>
          </div>
          <div class="col-12">
            <button
              mat-stroked-button
              class="w-100 izy-button-ghost custom-button-border"
              (click)="cancelEdit(); isEditMode = false"
              [disabled]="isLoading"
            >
              <mat-icon>cancel</mat-icon>
              Annulla
            </button>
          </div>
        </ng-container>
      </div>
    </div>

  </div>

  <div *ngIf="isLoading" class="loading-overlay">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Salvataggio in corso...</p>
  </div>
